import { fromJS } from 'immutable';
import { SET_ASSIGNED_CLAIMS_BY_SUB_SERVICES } from 'containers/CourtManagerAssignedClaims/constants';
import { AssignmentAction } from 'containers/CourtManagerAssignedClaims/typings';
import get from 'lodash/get';
import { RESET_STORE } from 'containers/LoginPage/constants';
import { SET_SEARCH } from 'containers/ValidatedClaimsPage/constants';

const initialState = fromJS({
  assignedClaims: [],
  assignedClaimsCount: 0,
});

const assignedClaimsReducer = (
  state = initialState,
  action: AssignmentAction,
) => {
  switch (action.type) {
    case SET_ASSIGNED_CLAIMS_BY_SUB_SERVICES:
      return state
        .set(
          'assignedClaims',
          fromJS(get(action.assignment, ['response', 'assignedClaims'], [])),
        )
        .set(
          'assignedClaimsCount',
          fromJS(
            get(action.assignment, ['response', 'assignedClaimsCount'], 0),
          ),
        );
    case SET_SEARCH:
      return state
        .set('assignedClaims', fromJS(action.data))
        .set('assignedClaimsCount', fromJS(get(action, 'data', []).length));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default assignedClaimsReducer;
